import { render, staticRenderFns } from "./geochat-main.vue?vue&type=template&id=1e35bfc8"
import script from "./geochat-main.vue?vue&type=script&lang=ts"
export * from "./geochat-main.vue?vue&type=script&lang=ts"
import style0 from "./geochat-main.vue?vue&type=style&index=0&id=1e35bfc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
